export enum ActionType {
    ReprocessingTask,
    OnlineJobs,
    Email,
    SendMail
}
